define('collections/targetingDimensions',["jQuery", "T1", "T1Collection", "models/targetingDimension"], function ($, T1, T1Collection, TargetingDimension) {
  T1.Models.TargetingDimension = T1Collection.extend({
    model: TargetingDimension,
    canCache: true,
    urlString: "targeting_dimensions"
  });
  return T1.Models.TargetingDimension;
});
